// translation keys for statuses
export const IN_PROGRESS = 'inProgress';
export const SHIPPED = 'shipped';
export const CANCELLED = 'cancelled';
export const FAILED = 'failed';
export const CANCEL_REQUESTED = 'cancelRequested';
export const COMPLETED = 'completed';

// ITEM STATES:

export const LineItemState = {
  ITEM_SHIPPED: 'Shipped',
  // In Progress status states
  ITEM_INITIAL: 'Initial',
  ITEM_SENT_TO_MCP: 'SentToMCP',
  // Cancel status states
  ITEM_CANCEL_SUCCESS: 'CancelSuccess',
  ITEM_CANCEL_FAILED: 'CancelFailed',
  ITEM_CANCEL_REQUESTED: 'CancelRequested',
  // Cancel status state set by ODUI once the cancellation request is sent
  ITEM_CANCEL_REQUEST_PENDING: 'CancelRequestPending',
  // Failed status states
  ITEM_REJECTED: 'Rejected',
  ITEM_FAILED: 'FailedItem',
} as const;
